import { render, staticRenderFns } from "./TabNoteDetail.vue?vue&type=template&id=4e4b1984&scoped=true&"
import script from "./TabNoteDetail.vue?vue&type=script&lang=js&"
export * from "./TabNoteDetail.vue?vue&type=script&lang=js&"
import style0 from "./TabNoteDetail.vue?vue&type=style&index=0&id=4e4b1984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b1984",
  null
  
)

export default component.exports